export const config = [
  {
    title: "4-Week Plan",
    reference: "core_4w_1w_r250801",
    retentionReference: "core_4w_1w_ret_r250801",
    uiDisplayOptions: {},
    upsellsTo: [
      {
        title: "6-pack Abs Plan",
        secondTitle: "Better Sex Plan",
        icon: "muscle", // new must be added via code
        secondIcon: "heartinfire",
        uiDisplayOptions: {
          focused: true,
          isCombined: true,
        },
        reference: "6kegel_4w_1w_r250801",
      },
      {
        title: "Kegel",
        icon: "heartinfire",
        reference: "kegel_4w_1w_r250801",
        uiDisplayOptions: {},
      },
      {
        title: "Six Pack",
        icon: "muscle",
        reference: "6pack_4w_1w_r250801",
        uiDisplayOptions: {},
      },
    ],
  },
  {
    title: "4-Week Plan",
    reference: "core_4w_r250801",
    retentionReference: "core_4w_ret_r250801",
    uiDisplayOptions: {
      title: "MOST POPULAR",
      focused: true,
      ignoreTrial: true,
    },
    upsellsTo: [
      {
        title: "6-pack Abs Plan",
        secondTitle: "Better Sex Plan",
        icon: "muscle",
        secondIcon: "heartinfire",
        uiDisplayOptions: {
          focused: true,
          isCombined: true,
        },
        reference: "6kegel_4w_r250801",
      },
      {
        title: "Kegel",
        icon: "heartinfire",
        reference: "kegel_4w_r250801",
        uiDisplayOptions: {},
      },
      {
        title: "Six Pack",
        icon: "muscle",
        reference: "6pack_4w_r250801",
        uiDisplayOptions: {},
      },
    ],
  },
  {
    title: "12-Week Plan",
    reference: "core_12w_r250801",
    additonalTitle: "",
    retentionReference: "core_12w_ret_r250801",
    uiDisplayOptions: {
      title: "RECOMMENDED FOR YOU",
      ignoreTrial: true,
    },
    upsellsTo: [
      {
        title: "6-pack Abs Plan",
        secondTitle: "Better Sex Plan",
        icon: "muscle", // new must be added via code
        secondIcon: "heartinfire",
        uiDisplayOptions: {
          focused: true,
          isCombined: true,
        },
        reference: "6kegel_12w_r250801",
      },
      {
        title: "Kegel",
        icon: "heartinfire",
        reference: "kegel_12w_r250801",
        uiDisplayOptions: {},
      },
      {
        title: "Six Pack",
        icon: "muscle",
        reference: "6pack_12w_r250801",
        uiDisplayOptions: {},
      },
    ],
  },
];

const commonUpsells = [
  {
    title: "6-pack Abs Plan",
    secondTitle: "Better Sex Plan",
    icon: "muscle",
    secondIcon: "heartinfire",
    uiDisplayOptions: { focused: true, isCombined: true },
  },
  { title: "Kegel", icon: "heartinfire", uiDisplayOptions: {} },
  { title: "Six Pack", icon: "muscle", uiDisplayOptions: {} },
];

export const PAYWALL_CONFIG = {
  DEFAULT_PAYWALL: [
    {
      title: "1-Week Plan",
      reference: "vanilla_easyfit_default_weeks4_weeks1",
      retentionReference: "vanilla_easyfit_retention_weeks4_weeks1",
      uiDisplayOptions: {
        legacyPlan: true,
      },
      upsellsTo: [
        {
          ...commonUpsells[0],
          reference: "vanilla_kegel_six_pack_default_weeks4_weeks1",
        },
        {
          ...commonUpsells[1],
          reference: "vanilla_kegel_default_weeks4_weeks1",
        },
        {
          ...commonUpsells[2],
          reference: "vanilla_six_pack_default_weeks4_weeks1",
        },
      ],
    },
    {
      title: "4-Week Plan",
      reference: "vanilla_easyfit_default_weeks4_days0",
      retentionReference: "vanilla_easyfit_retention_weeks4_days0",
      uiDisplayOptions: {
        title: "MOST POPULAR",
        legacyPlan: true,
        focused: true,
      },
      upsellsTo: [
        {
          ...commonUpsells[0],
          reference: "vanilla_six_pack_kegel_default_weeks4_days0",
        },
        {
          ...commonUpsells[1],
          reference: "vanilla_kegel_default_weeks4_days0",
        },
        {
          ...commonUpsells[2],
          reference: "vanilla_six_pack_default_weeks4_days0",
        },
      ],
    },
    {
      title: "12-Week Plan",
      reference: "vanilla_easyfit_default_weeks12_days0",
      additonalTitle: "",
      retentionReference: "vanilla_easyfit_retention_weeks12_days0",
      uiDisplayOptions: {
        title: "RECOMMENDED FOR YOU",
        legacyPlan: true,
      },
      upsellsTo: [
        {
          ...commonUpsells[0],
          reference: "vanilla_six_pack_kegel_default_weeks12_days0",
        },
        {
          ...commonUpsells[1],
          reference: "vanilla_kegel_default_weeks12_days0",
        },
        {
          ...commonUpsells[2],
          reference: "vanilla_six_pack_default_weeks12_days0",
        },
      ],
    },
  ],

  SOMATIC_PAYWALL: [
    {
      title: "1-Week Plan",
      reference: "vanilla_somatic_default_weeks4_weeks1",
      retentionReference: "vanilla_somatic_retention_weeks4_weeks1",
      uiDisplayOptions: {
        legacyPlan: true,
      },
      upsellsTo: [
        {
          ...commonUpsells[0],
          reference: "vanilla_kegel_six_pack_default_weeks4_weeks1",
        },
        {
          ...commonUpsells[1],
          reference: "vanilla_kegel_default_weeks4_weeks1",
        },
        {
          ...commonUpsells[2],
          reference: "vanilla_six_pack_default_weeks4_weeks1",
        },
      ],
    },
    {
      title: "4-Week Plan",
      reference: "vanilla_somatic_default_weeks4_days0",
      retentionReference: "vanilla_somatic_retention_weeks4_days0",
      uiDisplayOptions: {
        title: "MOST POPULAR",
        focused: true,
        legacyPlan: true,
      },
      upsellsTo: [
        {
          ...commonUpsells[0],
          reference: "vanilla_six_pack_kegel_default_weeks4_days0",
        },
        {
          ...commonUpsells[1],
          reference: "vanilla_kegel_default_weeks4_days0",
        },
        {
          ...commonUpsells[2],
          reference: "vanilla_six_pack_default_weeks4_days0",
        },
      ],
    },
    {
      title: "12-Week Plan",
      reference: "vanilla_somatic_default_weeks12_days0",
      additonalTitle: "",
      retentionReference: "vanilla_somatic_retention_weeks12_days0",
      uiDisplayOptions: { title: "RECOMMENDED FOR YOU", legacyPlan: true },
      upsellsTo: [
        {
          ...commonUpsells[0],
          reference: "vanilla_six_pack_kegel_default_weeks12_days0",
        },
        {
          ...commonUpsells[1],
          reference: "vanilla_kegel_default_weeks12_days0",
        },
        {
          ...commonUpsells[2],
          reference: "vanilla_six_pack_default_weeks12_days0",
        },
      ],
    },
  ],

  QUIZ_PAYWALL: [
    {
      title: "1-Week Plan",
      focused: true,
      reference: "vanilla_easyfit_default_weeks4_weeks1",
      retentionReference: "vanilla_easyfit_retention_weeks4_weeks1",
      uiDisplayOptions: {
        legacyPlan: true,
      },
      upsellsTo: [
        {
          ...commonUpsells[0],
          reference: "vanilla_kegel_six_pack_default_weeks4_weeks1",
        },
        {
          ...commonUpsells[1],
          reference: "vanilla_kegel_default_weeks4_weeks1",
        },
        {
          ...commonUpsells[2],
          reference: "vanilla_six_pack_default_weeks4_weeks1",
        },
      ],
    },
    {
      title: "4-Week Plan",
      reference: "vanilla_easyfit_default_weeks4_days0",
      retentionReference: "vanilla_easyfit_retention_weeks4_days0",
      uiDisplayOptions: {
        title: "MOST POPULAR",
        focused: true,
        legacyPlan: true,
      },
      upsellsTo: [
        {
          ...commonUpsells[0],
          reference: "vanilla_six_pack_kegel_default_weeks4_days0",
        },
        {
          ...commonUpsells[1],
          reference: "vanilla_kegel_default_weeks4_days0",
        },
        {
          ...commonUpsells[2],
          reference: "vanilla_six_pack_default_weeks4_days0",
        },
      ],
    },
    {
      title: "12-Week Plan",
      reference: "vanilla_easyfit_default_weeks12_days0",
      additonalTitle: "",
      retentionReference: "vanilla_easyfit_retention_weeks12_days0",
      uiDisplayOptions: { title: "RECOMMENDED FOR YOU", legacyPlan: true },
      upsellsTo: [
        {
          ...commonUpsells[0],
          reference: "vanilla_six_pack_kegel_default_weeks12_days0",
        },
        {
          ...commonUpsells[1],
          reference: "vanilla_kegel_default_weeks12_days0",
        },
        {
          ...commonUpsells[2],
          reference: "vanilla_six_pack_default_weeks12_days0",
        },
      ],
    },
  ],

  WALKY_PAYWALL_V1: [
    {
      title: "4-Week Plan",
      reference: "core_walky_4w_1w_r250807",
      retentionReference: "core_walky_4w_1w_ret_r250807",
      uiDisplayOptions: {},
      upsellsTo: [
        {
          title: "6-pack Abs Plan",
          secondTitle: "Better Sex Plan",
          icon: "muscle", // new must be added via code
          secondIcon: "heartinfire",
          uiDisplayOptions: {
            focused: true,
            isCombined: true,
          },
          reference: "6kegel_4w_1w_r250801",
        },
        {
          title: "Kegel",
          icon: "heartinfire",
          reference: "kegel_4w_1w_r250801",
          uiDisplayOptions: {},
        },
        {
          title: "Six Pack",
          icon: "muscle",
          reference: "6pack_4w_1w_r250801",
          uiDisplayOptions: {},
        },
      ],
    },
    {
      title: "4-Week Plan",
      reference: "core_walky_4w_r250807",
      retentionReference: "core_walky_4w_ret_r250807",
      uiDisplayOptions: {
        title: "MOST POPULAR",
        focused: true,
        ignoreTrial: true,
      },
      upsellsTo: [
        {
          title: "6-pack Abs Plan",
          secondTitle: "Better Sex Plan",
          icon: "muscle",
          secondIcon: "heartinfire",
          uiDisplayOptions: {
            focused: true,
            isCombined: true,
          },
          reference: "6kegel_4w_r250801",
        },
        {
          title: "Kegel",
          icon: "heartinfire",
          reference: "kegel_4w_r250801",
          uiDisplayOptions: {},
        },
        {
          title: "Six Pack",
          icon: "muscle",
          reference: "6pack_4w_r250801",
          uiDisplayOptions: {},
        },
      ],
    },
    {
      title: "12-Week Plan",
      reference: "core_walky_12w_r250807",
      additonalTitle: "",
      retentionReference: "core_walky_12w_ret_r250807",
      uiDisplayOptions: {
        title: "RECOMMENDED FOR YOU",
        ignoreTrial: true,
      },
      upsellsTo: [
        {
          title: "6-pack Abs Plan",
          secondTitle: "Better Sex Plan",
          icon: "muscle", // new must be added via code
          secondIcon: "heartinfire",
          uiDisplayOptions: {
            focused: true,
            isCombined: true,
          },
          reference: "6kegel_12w_r250801",
        },
        {
          title: "Kegel",
          icon: "heartinfire",
          reference: "kegel_12w_r250801",
          uiDisplayOptions: {},
        },
        {
          title: "Six Pack",
          icon: "muscle",
          reference: "6pack_12w_r250801",
          uiDisplayOptions: {},
        },
      ],
    },
  ],

  WALKY_PAYWALL_V2: [
    {
      title: "4-Week Plan",
      reference: "core_walky_4w_1w_r250909",
      retentionReference: "core_walky_4w_1w_ret_r250909",
      uiDisplayOptions: {},
      upsellsTo: [
        {
          title: "6-pack Abs Plan",
          secondTitle: "Better Sex Plan",
          icon: "muscle", // new must be added via code
          secondIcon: "heartinfire",
          uiDisplayOptions: {
            focused: true,
            isCombined: true,
          },
          reference: "6kegel_4w_1w_r250801",
        },
        {
          title: "Kegel",
          icon: "heartinfire",
          reference: "kegel_4w_1w_r250801",
          uiDisplayOptions: {},
        },
        {
          title: "Six Pack",
          icon: "muscle",
          reference: "6pack_4w_1w_r250801",
          uiDisplayOptions: {},
        },
      ],
    },
    {
      title: "4-Week Plan",
      reference: "core_walky_4w_r250909",
      retentionReference: "core_walky_4w_ret_r250909",
      uiDisplayOptions: {
        title: "MOST POPULAR",
        focused: true,
        ignoreTrial: true,
      },
      upsellsTo: [
        {
          title: "6-pack Abs Plan",
          secondTitle: "Better Sex Plan",
          icon: "muscle",
          secondIcon: "heartinfire",
          uiDisplayOptions: {
            focused: true,
            isCombined: true,
          },
          reference: "6kegel_4w_r250801",
        },
        {
          title: "Kegel",
          icon: "heartinfire",
          reference: "kegel_4w_r250801",
          uiDisplayOptions: {},
        },
        {
          title: "Six Pack",
          icon: "muscle",
          reference: "6pack_4w_r250801",
          uiDisplayOptions: {},
        },
      ],
    },
    {
      title: "12-Week Plan",
      reference: "core_walky_12w_r250909",
      additonalTitle: "",
      retentionReference: "core_walky_12w_ret_r250909",
      uiDisplayOptions: {
        title: "RECOMMENDED FOR YOU",
        ignoreTrial: true,
      },
      upsellsTo: [
        {
          title: "6-pack Abs Plan",
          secondTitle: "Better Sex Plan",
          icon: "muscle", // new must be added via code
          secondIcon: "heartinfire",
          uiDisplayOptions: {
            focused: true,
            isCombined: true,
          },
          reference: "6kegel_12w_r250801",
        },
        {
          title: "Kegel",
          icon: "heartinfire",
          reference: "kegel_12w_r250801",
          uiDisplayOptions: {},
        },
        {
          title: "Six Pack",
          icon: "muscle",
          reference: "6pack_12w_r250801",
          uiDisplayOptions: {},
        },
      ],
    },
  ],

  QUIZ_PAYWALL_V2: [...config],
};
